import React from "react";

const BasicCard = ({ children, bg, display, small, customClass, ...props }) => {
  return (
    <>
      <div
        {...props}
        className={`basic_card ${bg} ${display} ${
          small ? "small" : ""
        } ${customClass}`}
      >
        {children}
      </div>
    </>
  );
};
BasicCard.defaultProps = {
  bg: "light",
  display: "block",
};

export default BasicCard;
